import React from "react";
import { screenStyles as styles } from "./complianceStyles";

export default function ComplianceSearchBar({ searchTerm, onChange }) {
    return (
        <div style={styles.searchBar}>
            <input
                type="search"
                value={searchTerm}
                onChange={event => onChange(event.target.value)}
                placeholder="Rechercher par nom..."
                aria-label="Rechercher dans le suivi conformité"
                style={styles.searchInput}
            />
            <button
                type="button"
                disabled={!searchTerm}
                onClick={() => onChange("")}
                style={styles.clear(Boolean(searchTerm))}
            >
                Effacer
            </button>
        </div>
    );
}
